import Flatpickr from 'stimulus-flatpickr'
import monthSelect from 'flatpickr/dist/plugins/monthSelect';
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'

export default class extends Flatpickr {
  connect() {
    const min_date = new Date();
    const max_date = new Date();
    this.config = {
      locale: Japanese,
      minDate: min_date.setMonth(min_date.getMonth() - 4),
      maxDate: max_date.setMonth(max_date.getMonth() + 12),
      plugins: [
        new monthSelect({
          dateFormat: "Y年m月",
        })
      ]
    }

    super.connect();
  }
}
